/// <reference path="typings/jquery/jquery.d.ts" />
/// <reference path="common/interfaces.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
})(TotalJobsGroup || (TotalJobsGroup = {}));
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Config;
    (function (Config) {
    })(Config = TotalJobsGroup.Config || (TotalJobsGroup.Config = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var RecentSearches;
    (function (RecentSearches) {
    })(RecentSearches = TotalJobsGroup.RecentSearches || (TotalJobsGroup.RecentSearches = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));
$(document).ready(function () {
    function safeConsoleLog(message) {
        if (console && typeof console.log === 'function') {
            try {
                console.log(message);
            }
            catch (e) {
            }
        }
    }
    function safeConsoleLogError(message, error) {
        safeConsoleLog(message + ' ' + error.message);
    }
    var headerAnalytics = null;
    var querystring = null;
    try {
        querystring = new TotalJobsGroup.Header.QueryString(window.location);
    }
    catch (querystringError) {
        safeConsoleLogError('Failed to initialise Header.Querystring.', querystringError);
    }
    try {
        var headerSearchOptions = new TotalJobsGroup.Header.SearchOptions(jQuery, TotalJobsGroup.localStorage, querystring, TotalJobsGroup.Config.Global, TotalJobsGroup.Config.Site);
        headerSearchOptions.initialize($('body'));
    }
    catch (searchOptionsError) {
        safeConsoleLogError('Failed to initialise Header.SearchOptions.', searchOptionsError);
    }
    try {
        TotalJobsGroup.RecentSearches.DropdownRenderer.renderDropdown($('#navbar-desktop-recent-search-container'), $('#header-desktop-search-keywords'), $('#header-desktop-search-location-text'));
    }
    catch (recentSearchesError) {
        safeConsoleLogError('Failed to initialise recent search UI.', recentSearchesError);
    }
    try {
        TotalJobsGroup.RecentSearches.DropdownRenderer.renderDropdown($('#navbar-mobile-keywords-recent-search-container'), $('#header-mobile-search-keywords'));
    }
    catch (recentSearchesError) {
        safeConsoleLogError('Failed to initialise recent search UI.', recentSearchesError);
    }
    try {
        TotalJobsGroup.RecentSearches.DropdownRenderer.renderDropdown($('#navbar-mobile-location-recent-search-container'), $('#header-mobile-search-location'));
    }
    catch (recentSearchesError) {
        safeConsoleLogError('Failed to initialise recent search UI.', recentSearchesError);
    }
    try {
        var accountDetails = new TotalJobsGroup.Header.AccountDetails(jQuery, window.location, TotalJobsGroup.Config.Global, TotalJobsGroup.IsJobsiteBrand);
        accountDetails.initialize($('body'), function () { });
    }
    catch (accountError) {
        safeConsoleLogError('Failed to initialise Header.AccountDetails.', accountError);
    }
    try {
        headerAnalytics = new TotalJobsGroup.Header.Analytics(jQuery, window.location, analytics, analLib);
    }
    catch (analyticsError) {
        safeConsoleLogError('Failed to initialise Header.Analytics.', analyticsError);
    }
    try {
        var headerSearch = new TotalJobsGroup.Header.Search(jQuery, window.location, headerAnalytics);
        headerSearch.initialize($('body'));
    }
    catch (searchError) {
        safeConsoleLogError('Failed to initialise Header.Search.', searchError);
    }
    var headerTracking = null;
    try {
        var tracking = headerTracking = new TotalJobsGroup.Header.Tracking(jQuery, headerAnalytics, s_gi);
        tracking.initialize($('body'));
    }
    catch (trackingError) {
        safeConsoleLogError('Failed to initialise Header.Tracking.', trackingError);
    }
    try {
        var headerToggleTracking = new TotalJobsGroup.Header.ToggleTracking(jQuery, headerTracking);
        headerToggleTracking.initialize($('body'));
    }
    catch (toggleTrackingError) {
        safeConsoleLogError('Failed to initialise Header.ToggleTracking.', toggleTrackingError);
    }
    try {
        var toggles = new TotalJobsGroup.Header.Toggles(jQuery);
        toggles.initialize();
    }
    catch (togglesError) {
        safeConsoleLogError('Failed to initialise Header.Toggles.', togglesError);
    }
    var cookies = null;
    try {
        cookies = new TotalJobsGroup.Header.Cookies();
    }
    catch (cookiesError) {
        safeConsoleLogError('Failed to initialise Header.Cookies.', cookiesError);
    }
});

//# sourceMappingURL=main.js.map
